import { store } from "../../appRedux/store/Store";
import { userSignOut } from "../../appRedux/actions/Actions";
import projectConfig from "@projectConfig";
import { getPublicUser } from "../../services/api/Api";
import { isActivePublicUser } from "../Scripts";

const { scope } = projectConfig.api;
const RETRY_ATTEMPTED = "_retried";

let pendingRefresh = null;
const refreshPublicSession = () => {
   if (!pendingRefresh) {
      pendingRefresh = getPublicUser(projectConfig.publicUser?.domain, scope).finally(() => {
         pendingRefresh = null;
      });
   }
   return pendingRefresh;
};

export const logOutUserAndRedirectToSignin = () => {
   localStorage.removeItem("publicID");
   localStorage.removeItem("pocJWT");
   localStorage.removeItem("isPublicUserLogged");
   if (projectConfig?.publicUser === true) {
      localStorage.setItem("publicLogging", "1");
   }
   store.dispatch(userSignOut());
};

// Authentication error handling and automatic logout
export const authErrorInterceptor = {
   responseError: (error) => {
      if (error?.response?.data?.message) {
         if (
            error?.response?.status !== 500 &&
            !error.response.data.message.includes("Invalid or expired token!")
         ) {
            // sessionStorage.setItem("errorOccurred", "true");
         }
      }

      const isProtectedRoute =
         !window.location.pathname.includes("maintenance") &&
         !window.location.pathname.includes("signup") &&
         !window.location.pathname.includes("signin") &&
         !window.location.pathname.includes("remindPassword") &&
         !window.location.pathname.includes("changePassword") &&
         !window.location.pathname.includes("restoreLogin") &&
         !window.location.pathname.includes("register");

      const status = error?.response?.status;
      const data = error?.response?.data;
      const message = (data?.error ?? data?.message)?.toLowerCase();

      const isAuthMessage =
         message?.includes("unauthorized") ||
         message?.includes("not authorized") ||
         message?.includes("invalid token") ||
         message?.includes("expired token") ||
         message?.includes("legacy token") ||
         message === "system.api.security.user_logged_out";

      const performLogout = () => {
         if (projectConfig?.publicUser) {
            logOutUserAndRedirectToSignin();
         } else if (window.location.pathname !== "/") {
            store.dispatch(userSignOut());
            window.location.assign("/signin");
         }
      };

      if (isProtectedRoute) {
         // Handle 401/403/500 with auth-related messages
         if (
            [401, 403, 500].includes(status) &&
            !error?.config?.headers?.["X-Auth-Validation"] &&
            isAuthMessage
         ) {
            performLogout();
         }

         // Handle public user 400 errors on legacy endpoints
         if (
            localStorage.getItem("isPublicUserLogged") === "true" &&
            error?.response?.config?.url?.includes("legacy") &&
            status === 400
         ) {
            store.dispatch(userSignOut());
            window.location.assign("/signin");
         }

         // Handle 503 Service Unavailable (technical break)
         if (status === 503) {
            performLogout();
         }
      }

      return Promise.reject(error);
   },
};

export const publicUserRetryInterceptor = {
   responseError: async (error, axiosInstance) => {
      if (isActivePublicUser() && !error.config[RETRY_ATTEMPTED]) {
         error.config[RETRY_ATTEMPTED] = true;
         try {
            await refreshPublicSession();
            return axiosInstance(error.config);
         } catch {
            return Promise.reject(error);
         }
      }
      return Promise.reject(error);
   },
};
